import eventBg from '../../../../assets/svgs/hidupkan_event.svg';
import musisiBg from '../../../../assets/svgs/musisi_berkualitas.svg';
import pelangganBg from '../../../../assets/svgs/jangkau_pelanggan.svg';
import incomeBg from '../../../../assets/svgs/passive_income.svg';

export const content = [
  {
    img: eventBg,
    title: 'Hidupkan Event atau Bisnismu',
    desc:
      'Buat event mu lebih terasa dan tarik lebih banyak pengunjung ke kafemu.',
  },
  {
    img: musisiBg,
    title: 'Musisi Berkualitas',
    desc: 'Temukan musisi dengan kualitas premium di platform kami.',
  },
  {
    img: pelangganBg,
    title: 'Bagikan Studiomu',
    desc: 'Jangkau lebih banyak pelanggan ke studio mu dengan platform ini.',
  },
  {
    img: incomeBg,
    title: 'Passive Income',
    desc: 'Dapatkan passive income dengan menyewakan alat musik tidak terpakai',
  },
];
